import React from 'react';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { ListBadge } from 'apps/sigma2-ui/src/copilot/components/ListBadges';
import { ListBadgeHolder } from 'apps/sigma2-ui/src/copilot/components/ListBadges';

export const SlateBadges: React.FC<{
  language: Phrases;
  averageReadiness: number;
}> = ({ language, averageReadiness }) => {
  return (
    <ListBadgeHolder>
      <ListBadge
        title={language.hiringCopilotMyListAverageReadinessTitle()}
        description={language.hiringCopilotMyListAverageReadinessDescription()}
        percent={averageReadiness}
      />
    </ListBadgeHolder>
  );
};
